"use strict";
/* File automatically generated! Do not add or modify anything as it will be overridden! */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountOpeningMeterReadsLazyQuery = exports.useAccountOpeningMeterReadsQuery = exports.AccountOpeningMeterReadsDocument = exports.OpeningMeterReadsFragmentDoc = void 0;
var client_1 = require("@apollo/client");
var Apollo = __importStar(require("@apollo/client"));
var defaultOptions = {};
exports.OpeningMeterReadsFragmentDoc = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment OpeningMeterReads on AccountSupplyPoint {\n    openingMeterReads {\n      readDate\n      submissionDateTime\n      registerReads {\n        readValue\n        timingCategory\n      }\n    }\n    supplyPoint {\n      sprn\n      fuelType\n      timezone\n    }\n  }\n"], ["\n  fragment OpeningMeterReads on AccountSupplyPoint {\n    openingMeterReads {\n      readDate\n      submissionDateTime\n      registerReads {\n        readValue\n        timingCategory\n      }\n    }\n    supplyPoint {\n      sprn\n      fuelType\n      timezone\n    }\n  }\n"])));
exports.AccountOpeningMeterReadsDocument = (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query AccountOpeningMeterReads($accountId: ID!) {\n    account(id: $accountId) {\n      id\n      accountSupplyPoints {\n        ...OpeningMeterReads\n      }\n    }\n  }\n  ", "\n"], ["\n  query AccountOpeningMeterReads($accountId: ID!) {\n    account(id: $accountId) {\n      id\n      accountSupplyPoints {\n        ...OpeningMeterReads\n      }\n    }\n  }\n  ", "\n"])), exports.OpeningMeterReadsFragmentDoc);
/**
 * __useAccountOpeningMeterReadsQuery__
 *
 * To run a query within a React component, call `useAccountOpeningMeterReadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountOpeningMeterReadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountOpeningMeterReadsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
function useAccountOpeningMeterReadsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.AccountOpeningMeterReadsDocument, options);
}
exports.useAccountOpeningMeterReadsQuery = useAccountOpeningMeterReadsQuery;
function useAccountOpeningMeterReadsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.AccountOpeningMeterReadsDocument, options);
}
exports.useAccountOpeningMeterReadsLazyQuery = useAccountOpeningMeterReadsLazyQuery;
var templateObject_1, templateObject_2;
